import { t } from 'i18next';
import * as yup from 'yup';

import { NAME_MAX_LENGTH } from 'companySettings/components/PartFinderAttributeValues/constants';
import { AttributeType } from 'companySettings/enums';
import { getEmptyErrorMessage } from 'core/yup';

export const upsertPartFinderAttributeSchema = () =>
  yup.object().shape({
    name: yup
      .string()
      .label(t('labelName'))
      .trim()
      .max(
        NAME_MAX_LENGTH,
        t('errorFieldMaxLength', { field: t('labelName'), length: NAME_MAX_LENGTH })
      )
      .nullable()
      .required(getEmptyErrorMessage(t('labelName'))),
    type: yup
      .mixed<AttributeType>()
      .label(t('labelType'))
      .oneOf(Object.values(AttributeType))
      .required(getEmptyErrorMessage(t('labelType'))),
  });
